import Navbar from "@/components/landing/Navbar";
import HeroSection from "@/components/landing/HeroSection";
import LoopSection from "@/components/landing/LoopSection";
import FeaturesSection from "@/components/landing/FeaturesSection";
import ComparisonSection from "@/components/landing/ComparisonSection";
import IntegrationsSection from "@/components/landing/IntegrationsSection";
import CTASection from "@/components/landing/CTASection";
import Footer from "@/components/landing/Footer";

const Landing = () => (
  <div className="landing-root min-h-screen bg-background">
    <Navbar />
    <HeroSection />
    <LoopSection />
    <FeaturesSection />
    <ComparisonSection />
    <IntegrationsSection />
    <CTASection />
    <Footer />
  </div>
);

export default Landing;
